import { render, staticRenderFns } from "./TransportImport.vue?vue&type=template&id=3be4c27a&scoped=true&"
import script from "./TransportImport.vue?vue&type=script&lang=js&"
export * from "./TransportImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be4c27a",
  null
  
)

export default component.exports